import { defineMessages } from 'react-intl';

export default defineMessages({
  besoinAide: {
    id: 'info_numero_police.header',
  },
  faq: {
    id: 'dashboard_auto.questions_frequents',
  },
  contact: {
    id: 'footer.contact_us',
  },
  contacts_utils: {
    id: 'others.contact.utils',
  },
  agent_title: {
    id: 'fab.agent.title',
  },
});
